import { useEffect, useMemo, useRef, useState } from 'react';
import EfVideo from '@elem/ui/ef-video';
import EfSpec from '@elem/ui/ef-spec';
import classNames from 'classnames';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { tab1Icon, tab2Icon, tab3Icon } from './Icon';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('Oasis.TabImg');
    const [active, setActive] = useState(0);
    const { locale = 'us' } = useRouter();
    // 动画
    const { isH5, isPad, isPC, isDesktop, isInit } = useMediaDevice();
    const video1PC: {
        [key: string]: any;
    } = {
        eu: [
            'https://websiteoss.ecoflow.com/upload/video/1744270533324/%E7%99%BD%E5%A4%A9%E5%A4%AA%E9%98%B3%E6%9D%BF%E4%BE%9B%E7%94%B5-EN.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744878406329/%E8%87%AA%E5%8F%91%E8%87%AA%E7%94%A8.png',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/video/1744271550997/%E7%99%BD%E5%A4%A9%E5%A4%AA%E9%98%B3%E6%9D%BF%E4%BE%9B%E7%94%B5-UK.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744878540321/%E8%87%AA%E5%8F%91%E8%87%AA%E7%94%A8.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/video/1744271307581/%E7%99%BD%E5%A4%A9%E5%A4%AA%E9%98%B3%E6%9D%BF%E4%BE%9B%E7%94%B5-DE.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744878675199/%E8%87%AA%E5%8F%91%E8%87%AA%E7%94%A8.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/video/1744271361228/%E7%99%BD%E5%A4%A9%E5%A4%AA%E9%98%B3%E6%9D%BF%E4%BE%9B%E7%94%B5-FR.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744878763700/%E8%87%AA%E5%8F%91%E8%87%AA%E7%94%A8.png',
        ],
        //以下暂未提供素材
        it: [
            'https://websiteoss.ecoflow.com/upload/video/1744270533324/%E7%99%BD%E5%A4%A9%E5%A4%AA%E9%98%B3%E6%9D%BF%E4%BE%9B%E7%94%B5-EN.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744878406329/%E8%87%AA%E5%8F%91%E8%87%AA%E7%94%A8.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/video/1744270533324/%E7%99%BD%E5%A4%A9%E5%A4%AA%E9%98%B3%E6%9D%BF%E4%BE%9B%E7%94%B5-EN.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744878406329/%E8%87%AA%E5%8F%91%E8%87%AA%E7%94%A8.png',
        ],
    };
    const video2PC: {
        [key: string]: any;
    } = {
        eu: ['https://websiteoss.ecoflow.com/upload/video/1744370277223/TOU-EN.mp4', 'https://websiteoss.ecoflow.com/upload/image/1744878406513/TOU.png'],
        uk: ['https://websiteoss.ecoflow.com/upload/video/1744271551485/TOU-UK.mp4', 'https://websiteoss.ecoflow.com/upload/image/1744878540488/TOU.png'],
        fr: ['https://websiteoss.ecoflow.com/upload/video/1744271361459/TOU-FR.mp4', 'https://websiteoss.ecoflow.com/upload/image/1744878763895/TOU.png'],
        de: ['https://websiteoss.ecoflow.com/upload/video/1744271307830/TOU-DE.mp4', 'https://websiteoss.ecoflow.com/upload/image/1744878675413/TOU.png'],
        it: ['https://websiteoss.ecoflow.com/upload/video/1744370277223/TOU-EN.mp4', 'https://websiteoss.ecoflow.com/upload/image/1744878406513/TOU.png'],
        es: ['https://websiteoss.ecoflow.com/upload/video/1744370277223/TOU-EN.mp4', 'https://websiteoss.ecoflow.com/upload/image/1744878406513/TOU.png'],
    };
    const tabs = [
        {
            label: t('tab1.title'),
            icon: tab1Icon,
            pc: video1PC[locale][0],
            posterPC: video1PC[locale][1],
            desc: t.rich('tab1.desc', {
                h: (v) => <span className="highlight">{v}</span>,
            }),
        },

        {
            label: t('tab2.title'),
            icon: tab2Icon,
            pc: video2PC[locale][0],
            posterPC: video2PC[locale][1],
            desc: t.rich('tab2.desc', {
                h: (v) => <span className="highlight">{v}</span>,
            }),
        },
    ];
    const [loaderVideo, setLoaderVideo] = useState(false);
    const currentTab = useMemo(() => (loaderVideo ? tabs[active] : { ...tabs[active], pc: '', pad: '' }), [active, loaderVideo]);

    const tabsLineRef = useRef<HTMLDivElement>(null);
    const handleChange = (e: MouseEvent, idx: number) => {
        if (!tabsLineRef.current) return;
        const target = e.target as HTMLDivElement;

        // 对准下面的条
        const { left, width } = target.getBoundingClientRect();
        const { left: parentLeft = left } = target.parentElement?.getBoundingClientRect() ?? {};
        const scrollX = (target.parentElement as HTMLDivElement).scrollLeft ?? 0;
        tabsLineRef.current.style.transform = `translateX(${left - parentLeft + scrollX}px)`;
        tabsLineRef.current.style.width = `${width}px`;

        // h5 情况下切换 tab 需要显示出来
        if (isH5) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }

        // 重新播放视频
        const video: HTMLVideoElement | null = document.querySelector(`#TabImg .video-${idx} video`);
        if (video) {
            video.currentTime = 0;
            video?.play();
        }
        setActive(idx);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            button_name: t(`tab${idx + 1}.title`),
            list_name: 'none',
        });
    };
    // 初始化
    const init = () => {
        if (!tabsLineRef.current) return;
        const target = tabsLineRef.current.parentElement?.querySelector('.container .tabs .item.active') as HTMLDivElement;
        const { left, width } = target.getBoundingClientRect();
        const { left: parentLeft = left } = target.parentElement?.getBoundingClientRect() ?? {};
        const scrollX = (target.parentElement as HTMLDivElement).scrollLeft ?? 0;
        tabsLineRef.current.style.transform = `translateX(${left - parentLeft + scrollX}px)`;
        tabsLineRef.current.style.width = `${width}px`;
    };
    useEffect(() => {
        init();
        if (typeof window === 'undefined') return;
        window.addEventListener('resize', init);
        return () => {
            window.removeEventListener('resize', init);
        };
    }, []);

    useEffect(() => {
        const scene1 = AniContainer.create({
            triggerElement: '#TabImg', // 触发元素
            triggerHook: 1, // 触发时机 1 进入 0 离开
            duration: '200%',
            offset: isPad ? '-10%' : 0,
            onProcess: (process: number) => {
                if (process > 0.28) {
                    // 重新播放视频
                    const video: HTMLVideoElement | null = document.querySelector(`#TabImg .video-${active} video`);
                    if (video) {
                        video?.play();
                    }
                }
            },
        });
        return () => {
            scene1.destroy();
        };
    }, [isPad, active]);

    useEffect(() => {
        if (isH5) return;
        const box = document.querySelector('#TabImg') as HTMLDivElement;
        const scene2 = AniContainer.create({
            triggerElement: '#TabImg', // 触发元素
            triggerHook: 0, // 触发时机 1 进入 0 离开
            offset: box.offsetHeight * 0.5,
            duration: box.offsetHeight * 0.2,
            syncFromTo: [[box, { opacity: 1 }, { opacity: 0 }, 0.1]],
        });
        return () => {
            scene2.destroy();
        };
    }, [isH5]);

    useEffect(() => {
        const loader = AniContainer.create({
            triggerElement: '#SmartInsights',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => setLoaderVideo(true),
        });

        return () => {
            loader.destroy();
        };
    }, []);

    return (
        <div className={`${styles.TheComp}`} id="TabImg">
            <EfSpec />
            <div className="container">
                <div className="video-box">
                    {tabs.map(
                        (i, idx) =>
                            isInit &&
                            (isPC || isDesktop ? (
                                <EfVideo
                                    className={` video-pc video-${idx} ${active === idx ? 'active' : ''}`}
                                    pc={i.pc}
                                    poster={i.posterPC}
                                    loop
                                    key={`pc-${idx}`}
                                    preload="none"
                                />
                            ) : (
                                <EfVideo
                                    className={` video-pad video-${idx} ${active === idx ? 'active' : ''}`}
                                    pc={i.pc}
                                    poster={i.posterPC}
                                    loop
                                    key={`pad-${idx}`}
                                    preload="none"
                                />
                            )),
                    )}
                </div>
                <div className="tabs">
                    {tabs.map((i, idx) => (
                        <div className={classNames('item', { active: active === idx })} onClick={(e) => handleChange(e, idx)} key={idx}>
                            {i.icon}
                            <span>{i.label}</span>
                        </div>
                    ))}
                    <div className="tabs-line" ref={tabsLineRef}></div>
                </div>
                <div className="desc">{currentTab.desc}</div>
            </div>
        </div>
    );
}
